module.exports = __webpack_public_path__ + "static/media/projectmanager.cdce63fe.jpg";